import * as React from "react"
import { Button } from "@/shared/ui/button"
import { cn } from "@/lib/utils"

/** Larger height + icons below `md`; default sizing from `md` up. */
const RecorderButton = React.forwardRef(({ className, ...props }, ref) => (
  <Button
    ref={ref}
    className={cn(
      "h-[52px] md:h-10",
      "[&_svg]:size-5 md:[&_svg]:size-4",
      "[&_img]:h-5 [&_img]:w-5 md:[&_img]:h-4 md:[&_img]:w-4",
      className
    )}
    {...props}
  />
))
RecorderButton.displayName = "RecorderButton"

export default RecorderButton
